import { formatNumber } from '@captaincause/lib/format'
import { tm } from '../tm'
import { HeadIcons } from './HeadIcons'
import i18n from './i18n'
import type { Locales } from '@captaincause/types'

interface ContributionsCountProps {
  count: number
  locale: Locales
  withSuffix?: boolean
  className?: string
  textClassName?: string
  size?: number
}

export function ContributionsCount({
  count,
  size = 3,
  locale,
  withSuffix = false,
  className = '',
  textClassName = '',
}: ContributionsCountProps) {
  if (!count) return null

  const t = i18n[locale]

  return (
    <div className={tm('flex w-fit items-center space-x-1', className)}>
      <HeadIcons size={size} />
      <span
        className={tm(
          'whitespace-nowrap text-sm font-medium leading-5 -tracking-[0.14px]',
          textClassName,
        )}
      >
        {formatNumber(count, locale)} {withSuffix ? t.contributions(count) : ''}
      </span>
    </div>
  )
}
